var calendar; // the calendar class
let calendarDate; // the selected date on the calendar
let isResultSection = false;
let ovulationResult;

document.addEventListener("DOMContentLoaded", function Calendar() {
  if (
    window.location.href.includes(
      "%D8%AD%D8%A7%D8%B3%D8%A8%D8%A9-%D8%A7%D9%84%D8%AF%D9%88%D8%B1%D8%A9-%D8%A7%D9%84%D8%B4%D9%87%D8%B1%D9%8A%D8%A9"
    ) ||
    window.location.href.includes(
      "%D8%AD%D8%A7%D8%B3%D8%A8%D8%A9-%D8%A7%D9%84%D8%AA%D8%A8%D9%88%D9%8A%D8%B6"
    ) ||
    window.location.href.includes(
      "%D8%AD%D8%A7%D8%B3%D8%A8%D8%A9-%D9%85%D9%88%D8%B9%D8%AF-%D8%A7%D9%84%D9%88%D9%84%D8%A7%D8%AF%D8%A9"
    )
  ) {
    let calendars = $(".js-calendar");

    for (calendarEl of calendars) {
      calendar = new FullCalendar.Calendar(calendarEl, {
        initialView: "dayGridMonth",
        selectable: false,

        dateClick: function (info) {
          if (isResultSection) {
            return;
          }
          const isDateValid = validateDate(info);

          if (isDateValid) {
            calendarDate = info.date;
            info.dayEl.classList.add("selected-date");
          } else {
            return;
          }

          for (let sibling of info.dayEl.parentNode.children) {
            if (sibling !== info.dayEl) {
              sibling.classList.remove("selected-date");
            }

            for (let tr of info.dayEl.parentNode.parentNode.children) {
              for (let children of tr.children) {
                if (children !== info.dayEl) {
                  children.classList.remove("selected-date");
                }
              }
            }
          }
        },

        events: [],
      });

      calendar.render();
    }
  }
});

$(document).on("click", ".js-calculate", function (e) {
  isResultSection = true;

  if (document.getElementById("calc-ovulation")) {
    calculateOvulation();
  } else {
    calculateBirthDate();
  }

  var cells = document.getElementsByClassName("popup__calendar");
  for (var i = 0; i < cells.length; i++) {
    cells[i].style["pointer-events"] = "none";
  }

  e.preventDefault();
});

$(document).on("click", ".js-close", function (e) {
  isResultSection = false;

  e.preventDefault();
});

$(document).on("click", ".js-redo-test", function (e) {
  isResultSection = false;

  var cells = document.getElementsByClassName("popup__calendar");
  for (var i = 0; i < cells.length; i++) {
    cells[i].style["pointer-events"] = "inherit";
  }

  e.preventDefault();
});

$(document).on("click", "#ovulationDate1", function (e) {
  setTimeout(() => {
    var highlight = document.getElementsByClassName("fc-highlight");
    for (var i = 0; i < highlight.length; i++) {
      highlight[i].classList.remove("fc-blue-highlight");
      highlight[i].classList.remove("fc-blue-light-highlight");
    }
  });

  updateMonthView(false);

  calendar.select(
    ovulationResult.ovulation.start,
    ovulationResult.ovulation.end
  );
});

$(document).on("click", "#ovulationDate2", function (e) {
  ovulationDate2();
});

function ovulationDate2() {
  setTimeout(() => {
    var highlight = document.getElementsByClassName("fc-highlight");
    for (var i = 0; i < highlight.length; i++) {
      highlight[i].classList.add("fc-blue-highlight");
    }
  });

  updateMonthView(true);

  calendar.select(
    ovulationResult.nextPeriod.start,
    ovulationResult.nextPeriod.end
  );
}

$(document).on("click", "#ovulationDate3", function (e) {
  setTimeout(() => {
    var highlight = document.getElementsByClassName("fc-highlight");

    for (var i = 0; i < highlight.length; i++) {
      highlight[i].classList.add("fc-blue-light-highlight");
    }
  });

  updateMonthView(true);

  calendar.select(ovulationResult.date);
});

function calculateOvulation() {
  const daysValue = document.getElementById("period_length").value;
  const val = daysValue / 2;
  const nbOfDays = Math.trunc(Math.ceil(val));

  // ovulation start
  const resDate = new Date();
  resDate.setFullYear(calendarDate.getFullYear());
  resDate.setMonth(calendarDate.getMonth());
  resDate.setDate(calendarDate.getUTCDate() + nbOfDays);

  const start = new Date();
  start.setFullYear(resDate.getFullYear());
  start.setMonth(resDate.getMonth());
  start.setDate(resDate.getUTCDate() - 2);

  const end = new Date();
  end.setFullYear(resDate.getFullYear());
  end.setMonth(resDate.getMonth());
  end.setDate(resDate.getUTCDate() + 4);
  // ovulation end

  // period start
  const daysInMonth = new Date(
    calendarDate.getFullYear(),
    calendarDate.getMonth() + 1,
    0
  ).getUTCDate();

  const nextPeriodDate = new Date();
  nextPeriodDate.setFullYear(calendarDate.getFullYear());
  nextPeriodDate.setMonth(calendarDate.getMonth() + 1);
  nextPeriodDate.setDate(calendarDate.getUTCDate() - (daysInMonth - daysValue));

  const startDate = new Date();
  startDate.setFullYear(nextPeriodDate.getFullYear());
  startDate.setMonth(nextPeriodDate.getMonth());
  startDate.setDate(nextPeriodDate.getUTCDate() - 2);

  const endDate = new Date();
  endDate.setFullYear(nextPeriodDate.getFullYear());
  endDate.setMonth(nextPeriodDate.getMonth());
  endDate.setDate(nextPeriodDate.getUTCDate() + 4);
  // period end

  ovulationResult = {
    date: nextPeriodDate,
    ovulation: {
      date: resDate,
      start,
      end,
    },
    nextPeriod: {
      start: startDate,
      end: endDate,
    },
  };
  if (
    window.location.href.includes(
      "%D8%AD%D8%A7%D8%B3%D8%A8%D8%A9-%D8%A7%D9%84%D8%AF%D9%88%D8%B1%D8%A9-%D8%A7%D9%84%D8%B4%D9%87%D8%B1%D9%8A%D8%A9"
    )
  ) {
    $("#ovulationDate2").click();
    ovulationDate2();
  } else {
    $("#ovulationDate1").click();
    updateMonthView(false);
  }
}

function calculateBirthDate() {
  const birthDate = new Date(calendarDate);
  birthDate.setDate(birthDate.getUTCDate() + 40 * 7);

  const month = birthDate.toLocaleString("default", { month: "long" });

  document.getElementById("birth-date-result").innerHTML =
    month + " " + birthDate.getFullYear();

  document.getElementById("birth-date-day").innerHTML = birthDate.getUTCDate();

  const weeks = weeksBetween(new Date(), birthDate) - 1;
  document.getElementById("pregnancy-weeks").innerHTML = 40 - weeks;

  function weeksBetween(d1, d2) {
    return Math.round((d2 - d1) / (7 * 24 * 60 * 60 * 1000));
  }
}

// check if the result date is displayed in the next month --> manually cause calendar to go to next month
function updateMonthView(isNextPeriod) {
  const compareDate = isNextPeriod
    ? ovulationResult.date
    : ovulationResult.ovulation.date;

  if (
    calendar.currentData.currentDate.getFullYear() < compareDate.getFullYear()
  ) {
    calendar.next();
  } else if (
    calendar.currentData.currentDate.getFullYear() > compareDate.getFullYear()
  ) {
    calendar.prev();
  } else if (
    calendar.currentData.currentDate.getMonth() < compareDate.getMonth()
  ) {
    calendar.next();
  } else if (
    calendar.currentData.currentDate.getMonth() > compareDate.getMonth()
  ) {
    calendar.prev();
  }
}

function toTimestamp(strDate) {
  var datum = Date.parse(strDate);
  return datum / 1000;
}

function validateDate(dateObj) {
  const element = document.getElementById("calc-ovulation");
  let monthsBack = 9;
  if (element) {
    monthsBack = 1;
  }

  let selectedDate = new Date(dateObj.date);

  var timeBefore = new Date();
  var today = new Date();

  selectedDate = toTimestamp(selectedDate);
  today = toTimestamp(today);

  timeBefore.setMonth(timeBefore.getMonth() - monthsBack);
  timeBefore = toTimestamp(timeBefore);

  return today >= selectedDate && selectedDate >= timeBefore;
}
